<div class="modal-header">
    <button class="close" type="button" mat-dialog-close aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">Notes History</h4>
</div>
<div class="modal-body">
    <p-table styleClass="p-datatable-striped" [value]="notes" [rows]="10" [paginator]="true">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="4">
                    No records found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Note</th>
                <th>Updated Date</th>
                <th>Updated By</th>
                <th>Business Unit</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{item?.noteDescription}}</td>
                <td>{{item?.updatedDate | date:'M/d/yyyy'}} {{item?.updatedDate | date:'shortTime'}}</td>
                <td>{{item?.updatedBy}}</td>
                <td>{{item?.businessUnit}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" mat-dialog-close aria-label="Close">Close</button>
    </div>
</div>
